
const TtsIcon = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 8C0 3.58172 3.58172 0 8 0H20C24.4183 0 28 3.58172 28 8V20C28 24.4183 24.4183 28 20 28H8C3.58172 28 0 24.4183 0 20V8Z" fill="#875BF7" />
    <g clipPath="url(#clip0_40041_21657)">
      <path d="M12.8462 12.8888V12.4614H14.7693M16.6923 12.8888V12.4614H14.7693M14.7693 12.4614V16.3076" stroke="white" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.6923 18.6157H17.8461" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.84614 5.53857V12.077M10.1538 7.07704V10.5386M12.4615 7.84627V9.76934M5.53845 7.84627V9.76934" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.7692 7.07715V7.07715C18.2421 7.07715 19.9785 7.07715 21.114 8.08311C21.2346 8.18997 21.3487 8.30403 21.4556 8.42466C22.4615 9.56015 22.4615 11.2966 22.4615 14.7695V14.7695C22.4615 18.2423 22.4615 19.9788 21.4556 21.1143C21.3487 21.2349 21.2346 21.3489 21.114 21.4558C19.9785 22.4618 18.2421 22.4618 14.7692 22.4618V22.4618C11.2963 22.4618 9.5599 22.4618 8.42441 21.4558C8.30379 21.3489 8.18973 21.2349 8.08286 21.1143C7.0769 19.9788 7.0769 18.2423 7.0769 14.7695V14.7695" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
    </g>
    <defs>
      <clipPath id="clip0_40041_21657">
        <rect width="20" height="20" fill="white" transform="translate(4 4)" />
      </clipPath>
    </defs>
  </svg>
)

export default TtsIcon
